import { Column, Sorting, TableColumnWidthInfo } from '@devexpress/dx-react-grid'
import { useEffect } from 'react'

interface useInitColumnsProps {
  setColumns: Function
  setColumnWidths: Function
  setDefaultSorting: Function
  sortRowsUrl?: string
  toggleActiveUrl?: string
}

const useInitColumns = (props: useInitColumnsProps) => {
  useEffect(() => {
    const columns: Array<Column> = []
    const columnWidths: Array<TableColumnWidthInfo> = []
    const defaultSorting: Array<Sorting> = []

    if (props.sortRowsUrl !== undefined) {
      columns.push({ name: 'sortColumn', title: ' ' })
      columns.push({ name: 'order', title: '#', getCellValue: (row) => Number.isInteger(row.order) ? (row.order + 1) : '-' })
      defaultSorting.push({ columnName: 'order', direction: 'asc' })

      columnWidths.push({ columnName: 'sortColumn', width: '10%' })
      columnWidths.push({ columnName: 'order', width: '10%' })
      columnWidths.push({ columnName: 'name', width: '40%' })
    } else {
      defaultSorting.push({ columnName: 'name', direction: 'asc' })
      columnWidths.push({ columnName: 'name', width: '60%' })
    }

    columns.push({ name: 'name', title: 'Name' })

    if (props.toggleActiveUrl !== undefined) {
      columns.push({ name: 'active', title: 'Active' })
      columnWidths.push({ columnName: 'active', width: '20%' })
      columnWidths.push({ columnName: 'action', width: '20%' })
    } else {
      columnWidths.push({ columnName: 'action', width: '40%' })
    }

    columns.push({ name: 'action', title: ' ' })

    props.setColumns(columns)
    props.setColumnWidths(columnWidths)
    props.setDefaultSorting(defaultSorting)
  }, [])
}

export default useInitColumns
